import { Typography } from '@euler/app/components/typography';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo } from 'react';
import { TextInput, View } from 'react-native';
import { designRoles } from '../../common/designRoles';

/** The draft as it stands, or being edited. */
export type DraftWellState =
  | { kind: 'read' }
  | {
      kind: 'edit';
      disabled: boolean;
      limit: number;
      onChangeText: (text: string) => void;
    };

/**
 * The message the draft would send: its status and expiry above, the words
 * in a sunken well; editing, the well is the text field, outlined in the
 * interactive blue, with its count against the limit.
 */
export const DraftWell = memo(
  ({
    status,
    text,
    state,
  }: {
    status: string;
    text: string;
    state: DraftWellState;
  }) => {
    const { rpx } = useResponsiveContext();
    const editing = state.kind === 'edit';
    return (
      <View style={{ marginTop: rpx(14) }}>
        <View
          style={{
            flexDirection: 'row',
            alignItems: 'baseline',
            gap: rpx(8),
          }}
        >
          <Typography.Text
            size={rpx(12)}
            color={designRoles.textSecondary}
            medium
          >
            拟发送消息
          </Typography.Text>
          <Typography.Text
            size={rpx(12)}
            color={designRoles.textTertiary}
            style={{ flexShrink: 1 }}
          >
            {status}
          </Typography.Text>
        </View>
        <View
          style={{
            marginTop: rpx(6),
            paddingHorizontal: rpx(12),
            paddingVertical: rpx(10),
            borderRadius: rpx(10),
            borderWidth: 1,
            borderColor: editing
              ? designRoles.interactive
              : designRoles.bgSunken,
            backgroundColor: editing
              ? designRoles.bgSurface
              : designRoles.bgSunken,
          }}
        >
          {state.kind === 'edit' ? (
            <TextInput
              accessibilityLabel="拟发送消息"
              value={text}
              onChangeText={state.onChangeText}
              editable={!state.disabled}
              multiline
              autoFocus
              // Sent to the customer as written: a plate or a product name
              // must not be corrected.
              autoCorrect={false}
              textAlignVertical="top"
              style={{
                fontSize: rpx(14),
                color: designRoles.textPrimary,
                padding: 0,
                minHeight: rpx(84),
              }}
            />
          ) : (
            <Typography.Text
              size={rpx(14)}
              lineHeight={rpx(21)}
              color={designRoles.textPrimary}
            >
              {text}
            </Typography.Text>
          )}
        </View>
        {state.kind === 'edit' ? (
          <Typography.Text
            size={rpx(12)}
            color={
              text.length > state.limit
                ? designRoles.statusDanger
                : designRoles.textTertiary
            }
            mt={rpx(4)}
            style={{ alignSelf: 'flex-end' }}
          >
            {`${text.length}/${state.limit} 字`}
          </Typography.Text>
        ) : null}
      </View>
    );
  },
);
